export default function useChangeComponent(emit) {
  function changeComponent(component, payload) {
    emit('change-component', { component, payload });
  }
  return { changeComponent };
}
